<template>
  <VuePerfectScrollbar
    fluid
    style="height: 60vh; overflow-y: auto"
  >
    <table
      class="table_1 table_2"
      style="width: 100%"
    >
      <tr style="position: sticky !important; top: 0 !important">
        <th style="min-width: 20px; max-width: 20px">
          <input
            @change="toggleAllCheck"
            v-model="allCheck"
            type="checkbox"
            class="office-staff-checkbox"
            style="height:"
          />
        </th>
        <th
          style="min-width: 250px; max-width: 250px; padding-left: 12px !important"
          colspan="2"
        >
          事業所名
        </th>
      </tr>
      <tr
        v-for="{ name, id } in offices"
        :key="id"
      >
        <td style="max-width: 20px; max-width: 20px">
          <input
            @change="handleOfficeChecked"
            v-model="form.offices"
            type="checkbox"
            :value="id"
            class="office-staff-checkbox"
          />
        </td>
        <td style="min-width: 250px; max-width: 250px; padding-left: 12px !important">{{ name }}</td>
      </tr>
    </table>
  </VuePerfectScrollbar>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    offices: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      allCheck: false,
    };
  },
  methods: {
    updateLoading(flg) {
      EventBus.$emit('updateLoading', flg);
    },
    async isOfficeHasStaffHavingTheWorkpattern(officeIds) {
      const url = this.$route('office-staff-workpattern.index');
      const res = await axios.get(url, {
        params: {
          office_ids: officeIds,
          workpattern_ids: [this.form.id],
        },
      });

      return res.data.length > 0;
    },
    async swalProceedUncheck() {
      const { isConfirmed } = await this.$swal({
        icon: 'warning',
        text: '勤務区分を削除しようとしている事業所には、該当の勤務区分が設定されている職員がいます。職員の勤務区分が削除されますがよろしいですか？（シフトパターンに指定されている固定シフトも対象です。）',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      });

      return isConfirmed;
    },
    swalErrorAlert() {
      this.$swal({
        icon: 'error',
        text: 'エラーが発生しました。再度お試しください。',
      });
    },
    /**
     * 全ての勤務区分を選択または解除する
     * 'allCheck' が true の場合、全ての勤務区分を選択
     * 'allCheck' が false の場合、全ての勤務区分を解除
     */
    async toggleAllCheck() {
      // チェックを入れた場合、全ての事業所を選択する
      if (this.allCheck) {
        this.$set(this.form, 'offices', this.allOfficeIds);
        return;
      }

      // 以下、チェックを外した場合の処理

      // 編集でない(新規作成・コピー)場合、そのまま全チェックを外す
      if (!this.isEdit) {
        this.$set(this.form, 'offices', []);
        return;
      }

      try {
        this.updateLoading(true);

        // 勤務区分を持っている事業所があるか確認
        if (!(await this.isOfficeHasStaffHavingTheWorkpattern(this.form.offices))) {
          this.$set(this.form, 'offices', []);
          return;
        }
      } catch {
        this.swalErrorAlert();
        this.allCheck = true;
        return;
      } finally {
        this.updateLoading(false);
      }
      
      // 勤務区分を持つ事業所がある場合、確認ダイアログを表示
      if (await this.swalProceedUncheck()) {
        // 確認ダイアログで「はい」を選択した場合、全ての勤務区分を解除する
        this.$set(this.form, 'offices', []);
      } else {
        // 確認ダイアログで「キャンセル」を選択した場合、全選択のチェックボックスを元に戻す（オンにする）
        this.allCheck = true;
      }
    },
    async handleOfficeChecked(e) {
      // チェックを入れた場合、そのままチェックを入れる
      if (e.target.checked) {
        return;
      }

      // 以下、チェックを外した場合の処理

      // 編集でない(新規作成・コピー)場合、そのままチェックを外す
      if (!this.isEdit) {
        this.allCheck = false;
        return;
      }

      const officeId = Number.parseInt(e.target.value);

      try {
        this.updateLoading(true);

        if (!(await this.isOfficeHasStaffHavingTheWorkpattern([officeId]))) {
          this.allCheck = false;
          return;
        }
      } catch (error) {
        this.swalErrorAlert();
        this.form.offices.push(officeId);
        return;
      } finally {
        this.updateLoading(false);
      }

      // 勤務区分を持つ事業所がある場合、確認ダイアログを表示
      if (await this.swalProceedUncheck()) {
        // 確認ダイアログで「はい」を選択した場合
        this.allCheck = false; // 全選択のチェックを外す
      } else {
        // 確認ダイアログで「キャンセル」を選択した場合、チェックを入れ直す
        this.form.offices.push(officeId);
      }
    },
  },
  computed: {
    // 新規作成(および複製)かどうか
    isEdit() {
      return this.form.id;
    },
    // 全ての事業所IDを配列で返す
    allOfficeIds() {
      return this.offices.map(({ id }) => id);
    },
  },
};
</script>
